import { ButtonBase, Grid } from '@mui/material';
import { Fragment, memo } from 'react';
import { useShowroom } from 'context';
import REPAIR_TYPE from 'shared/repairTypeList';
import { Trans } from 'react-i18next';
import { NumericFormat } from 'react-number-format';
import { formatMultiplies } from 'utils/formatOddDecimal';

export default memo(function Floor({
  size,
  homes,
  floorNumber,
  index,
  settingsMenuValue = 'square',
}) {
  const [, dispatch] = useShowroom();
  const onClick = (e, id) => {
    document
      ?.querySelector('.showroom-wrapper')
      ?.querySelectorAll('.item-selected')
      ?.forEach((el) => el?.classList?.remove('item-selected'));
    e?.target?.classList?.toggle('item-selected');
    dispatch({ type: 'setHomeId', payload: id });
  };
  return (
    <Fragment>
      <Grid
        container
        rowSpacing={1}
        columns={{
          xs: parseInt(size),
          sm: parseInt(size),
        }}
        key={`container-${floorNumber}`}
        className='sheet-home-row'
      >
        {/* {index == 0 && ( */}
        <Grid item={true} sm={1} xs={1} className='!max-w-fit'>
          <ButtonBase
            className='sheet-home-row-floor h-full w-8 !-ml-3 !mr-1 text-sm font-medium !cursor-default'
            disableRipple
          >
            {floorNumber}
          </ButtonBase>
        </Grid>
        {/* )} */}
        {homes.filter((home) => home.stage == floorNumber).length > 0
          ? homes
              .filter((home) => home.stage == floorNumber)
              .map(
                (item) => (
                  // item?.contract?.id ? (
                  //   <Grid
                  //     item={true}
                  //     sm={1}
                  //     xs={1}
                  //     key={`block-${index}-home-${item.id}`}
                  //     className={`sheet-home-cell showroom-plus floor-${floorNumber}`}
                  //     id={`block-${index}-home-${item.id}`}
                  //   >
                  //     <ButtonBase
                  //       className={`block-${index}-home home-item relative showroom-plus status-${
                  //         item?.contract?.status == 2 ? 'completed' : item?.status
                  //       }${item.disabled ? ' is-disabled' : ''}`}
                  //       id={`home-${item.id}`}
                  //       onClick={(e) => onClick(e, item?.id)}
                  //     >
                  //       {item?.contract?.is_notarial == 1 ? (
                  //         <div className='absolute -top-1 -right-1 w-3 h-3 rounded bg-[#FFD700] shadow-md' />
                  //       ) : (
                  //         ''
                  //       )}
                  //       {!(item.stage && parseInt(item.stage) < 0) ? (
                  //         <Fragment>
                  //           <div className='home-item-data'>
                  //             <span className='whitespace-nowrap mr-1'>
                  //               №: {item.number}
                  //             </span>
                  //             {item?.contract?.sum &&
                  //               item?.contract.hasOwnProperty('discount') &&
                  //               item?.square && (
                  //                 <NumericFormat
                  //                   value={
                  //                     (parseFloat(item.contract.sum) -
                  //                       parseFloat(item.contract.discount)) /
                  //                     parseFloat(item.contract.square)
                  //                   }
                  //                   allowNegative={false}
                  //                   displayType={'text'}
                  //                   thousandSeparator={' '}
                  //                   decimalScale={1}
                  //                   className='w-full text-right'
                  //                   suffix={
                  //                     item?.contract?.isvalute == '1' ? ' $' : ''
                  //                   }
                  //                 />
                  //               )}
                  //           </div>
                  //           <div className='home-item-data'>
                  //             {item?.contract?.sum &&
                  //               item?.contract.hasOwnProperty('discount') && (
                  //                 <NumericFormat
                  //                   value={
                  //                     item.contract.sum - item.contract.discount
                  //                   }
                  //                   allowNegative={false}
                  //                   displayType={'text'}
                  //                   thousandSeparator={' '}
                  //                   decimalScale={1}
                  //                   className='w-full text-center'
                  //                   suffix={
                  //                     item?.contract?.isvalute == '1'
                  //                       ? ' $'
                  //                       : ' UZS'
                  //                   }
                  //                 />
                  //               )}
                  //           </div>
                  //           <div className='home-item-data'>
                  //             <span>{item.rooms}x</span>
                  //             <span>
                  //               <NumericFormat
                  //                 value={item?.square}
                  //                 allowNegative={false}
                  //                 displayType={'text'}
                  //                 decimalScale={2}
                  //                 className='w-full text-right'
                  //               />
                  //               <Trans i18nKey='common.global.meter'>
                  //                 m<sup>2</sup>
                  //               </Trans>
                  //             </span>
                  //           </div>
                  //         </Fragment>
                  //       ) : (
                  //         <div className='h-[68px] flex items-center justify-center text-xl'>
                  //           P
                  //         </div>
                  //       )}
                  //     </ButtonBase>
                  //   </Grid>
                  // ) : (
                  <Grid
                    item={true}
                    sm={1}
                    xs={1}
                    key={`block-${index}-home-${item.id}`}
                    id={`block-${index}-home-${item.id}`}
                    className={`sheet-home-cell showroom-plus floor-${floorNumber}`}
                  >
                    <ButtonBase
                      className={`block-${index}-home home-item relative showroom-plus status-${
                        item?.contract?.status == 2
                          ? 'completed'
                          : item?.status == 3 &&
                            item?.contract?.is_complete == 1
                          ? 'half-completed'
                          : item?.status
                      }${item.disabled ? ' is-disabled' : ''}`}
                      id={`home-${item.id}`}
                      onClick={(e) => onClick(e, item?.id)}
                    >
                      {item?.contract?.is_notarial == 1 ? (
                        <div className='absolute -top-1 -right-1 w-3 h-3 rounded bg-[#FFD700] shadow-md' />
                      ) : (
                        ''
                      )}
                      {!(item.stage && parseInt(item.stage) < -2) ? (
                        <Fragment>
                          <div className='home-item-data'>
                            <span className='whitespace-nowrap'>
                              №: {item.number}
                            </span>
                            {item.isrepaired == REPAIR_TYPE.REPAIRED.code ? (
                              <NumericFormat
                                value={item.repaired || ''}
                                allowNegative={false}
                                displayType={'text'}
                                thousandSeparator={' '}
                                decimalScale={1}
                                className='w-full text-right'
                                suffix={item?.isvalute == '1' ? ' $' : ''}
                              />
                            ) : (
                              <NumericFormat
                                value={item.norepaired || ''}
                                allowNegative={false}
                                displayType={'text'}
                                thousandSeparator={' '}
                                decimalScale={1}
                                className='w-full text-right'
                                suffix={item?.isvalute == '1' ? ' $' : ''}
                              />
                            )}
                          </div>
                          <div className='home-item-data'>
                            {item.isrepaired == REPAIR_TYPE.REPAIRED.code ? (
                              <NumericFormat
                                value={
                                  item.repaired && item.square
                                    ? formatMultiplies(
                                        [item.repaired, item.square],
                                        2
                                      )
                                    : 0
                                }
                                allowNegative={false}
                                displayType={'text'}
                                thousandSeparator={' '}
                                decimalScale={1}
                                className='w-full text-center'
                                suffix={item?.isvalute == '1' ? ' $' : ' UZS'}
                              />
                            ) : (
                              <NumericFormat
                                value={
                                  item.norepaired && item.square
                                    ? formatMultiplies(
                                        [item.norepaired, item.square],
                                        2
                                      )
                                    : 0
                                }
                                allowNegative={false}
                                displayType={'text'}
                                thousandSeparator={' '}
                                decimalScale={1}
                                className='w-full text-center'
                                suffix={item?.isvalute == '1' ? ' $' : ' UZS'}
                              />
                            )}
                          </div>
                          <div className='home-item-data'>
                            <span>{item.rooms}x</span>
                            <span>
                              <NumericFormat
                                value={item?.square}
                                allowNegative={false}
                                displayType={'text'}
                                decimalScale={2}
                                className='w-full text-right'
                              />{' '}
                              <Trans i18nKey='common.global.meter'>
                                m<sup>2</sup>
                              </Trans>
                            </span>
                          </div>
                        </Fragment>
                      ) : (
                        <div className='h-[68px] flex items-center justify-center text-xl'>
                          P
                        </div>
                      )}
                    </ButtonBase>
                  </Grid>
                )
                // )
              )
          : [1].map((item) => (
              <Grid
                item={true}
                sm={1}
                xs={1}
                key={`home-empty-${item}`}
                className={`sheet-home-cell showroom-plus sheet-home-empty-cell floor-${floorNumber}`}
              >
                <ButtonBase className='home-item showroom-plus is-empty'>
                  <div className='home-item-data'></div>
                </ButtonBase>
              </Grid>
            ))}
      </Grid>
    </Fragment>
  );
});
